import React from 'react';

import {
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    InputLabel,
} from '@mui/material';
import { useTranslation } from 'core/contexts/localization';

export const SelectComponent = (props) => {
    const { input, value, id, meta, label, name, options, disabled } = props;
    const { t: translate } = useTranslation();
    const [startValue, setStartValue] = React.useState(props.startWithValue);
    console.log('cancel ===', props.clickedCancel);
    React.useEffect(() => {
        setStartValue(props.startWithValue);
    }, [props.startWithValue]);

    React.useEffect(() => {
        if (props.clickedCancel) {
            setStartValue(props.startWithValue);
        }
    }, [props.clickedCancel]);

    console.log(
        'select component ===',
        startValue,
        ' props ',
        props.startWithValue
    );
    return (
        <FormControl
            variant="outlined"
            error={meta.touched ? !!meta.error : false}
        >
            <InputLabel disabled={disabled || false} id={id}>
                {label || ''}
            </InputLabel>
            <Select
                variant="outlined"
                id={id || ''}
                error={meta.touched ? !!meta.error : false}
                disabled={disabled || false}
                name={name}
                value={startValue || 'N/A'}
                label={label || ''}
                // helperText={meta.touched ? meta.error : ''}
                onChange={(value) => {
                    if (props.onFieldChange) {
                        props.onFieldChange(value.target.value);
                    }
                    setStartValue(value.target.value);
                    // input.onChange(value.target.value);
                }}
            >
                {options?.map((value) => (
                    <MenuItem
                        style={{ color: 'black' }}
                        key={value.value}
                        value={value.value}
                        label={value.label}
                    >
                        {translate(value.value)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
